import * as React from "react"
import { Route } from "react-router-dom"
import AuthorizedFunction from "../../config/AuthorizedFunction"

export const PrivateRoute = ({ component: Component, roles, ...rest }) => {
  return (
    AuthorizedFunction(roles) && (
      <Route
        {...rest}
        render={props => {
          return <Component {...props} />
        }}
      />
    )
  )
}
